import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../Config'; // o '../Config' si el path cambia


export default function FlujoCajaAdmin() {
  const [ventas, setVentas] = useState([]);

useEffect(() => {
  const fetchVentasYPropinas = async () => {
    try {
      const [ventasRes, propinasRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/ventas`),
        axios.get(`${API_BASE_URL}/api/propinas`),
      ]);

      const propinasMap = {};
      propinasRes.data.forEach((p) => {
        propinasMap[p.id] = p.monto;
      });

      const ventasConPropina = ventasRes.data.map((venta) => ({
        ...venta,
        montoPropina: propinasMap[venta.propinaId] || 0,
      }));

      setVentas(ventasConPropina);
    } catch (err) {
      console.error('Error al cargar datos:', err);
    }
  };

  fetchVentasYPropinas();
}, []);



  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">💰 Flujo de Caja</h2>

      <table className="w-full table-auto border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">ID</th>
            <th className="border p-2">Fecha</th>
            <th className="border p-2">Total (Gs)</th>
            <th className="border p-2">Propina</th>
            <th className="border p-2">Método de Pago</th>
            <th className="border p-2">Cantidad</th>
            <th className="border p-2">Producto</th>
          </tr>
        </thead>
        <tbody>
          {ventas.map((venta) => (
            <tr key={venta.id}>
              <td className="border p-2">{venta.id}</td>
              <td className="border p-2">{new Date(venta.fecha).toLocaleString()}</td>
              <td className="border p-2">{venta.total}</td>
<td className="border p-2">{venta.montoPropina}</td>
              <td className="border p-2">{venta.metodoPago}</td>
              <td className="border p-2">{venta.cantidad}</td>
              <td className="border p-2">{venta.nombre}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
